/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_OverlapInputs */

const en_issue_overlap = /** @type {(inputs: Issue_OverlapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`overlaps another band`)
};

/**
* | output |
* | --- |
* | "overlaps another band" |
*
* @param {Issue_OverlapInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_overlap = /** @type {((inputs?: Issue_OverlapInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_OverlapInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_overlap(inputs)
});